import { useEffect, useState } from 'react';
import { DEFAULT_SCOPE, getScope, Scope } from '../data/cache';

/* meta/scope: which Knesset and government the live data describes. One read per page
   load; DEFAULT_SCOPE until it arrives. The value is also kept synchronously, so the
   shells (which remount with every page) render it on their first render after that. */
let scopeValue: Scope | null = null;

export const useScope = (): Scope => {
  const [value, setValue] = useState<Scope>(scopeValue || DEFAULT_SCOPE);
  useEffect(() => {
    let alive = true;
    getScope().then(s => { scopeValue = s; if (alive) setValue(s); });
    return () => { alive = false; };
  }, []);
  return value;
};

// The Knesset a page shows for its `k` URL param: an archived Knesset when the param names
// one, else the current Knesset
export const knessetFromParam = (raw: string | null, scope: Scope): number => {
  const k = Number(raw);
  return k && k !== scope.knesset && scope.archivedKnessets.indexOf(k) !== -1 ? k : scope.knesset;
};

// The most recent archived Knesset (the one before the current Knesset), or null
export const previousKnesset = (scope: Scope): number | null => {
  const earlier = scope.archivedKnessets.filter(k => k < scope.knesset).sort((a, b) => b - a);
  return earlier.length > 0 ? earlier[0] : null;
};

// '10 בנובמבר': the day the current Knesset's first plenum met (Israel time), or ''
export const swornInLabel = (scope: Scope): string => {
  const t = scope.knessets[String(scope.knesset)];
  return t ? new Date(t.start).toLocaleDateString('he-IL', { timeZone: 'Asia/Jerusalem', day: 'numeric', month: 'long' }) : '';
};
